// after subscribed to a paid plan
export const showPlanUsageProgressBar = (plan) => {
	if (!(plan?.type && plan?.state)) return false;
	const planType = plan.type.toLowerCase();
	const planState = plan.state.toLowerCase();
	return planType !== "trial" && planState === "active";
};
// while calculating
export const showAnalyzeProgressBar = (segState, last30DaysHitsTotal) => {
	if (segState?.toLowerCase() === "active") return false;
	if (isNaN(last30DaysHitsTotal) && isNaN(parseInt(last30DaysHitsTotal))) {
		last30DaysHitsTotal = 0;
	}
	return parseInt(last30DaysHitsTotal) < 500 || segState?.toLowerCase() === "calculating";
};
// After successful integration
export const showFBIntegrationSuccessful = (seg) => {
	return !!seg?.install_data?.options?.fb && !!seg?.install_data?.options?.capi && localStorage.getItem(`${seg?.code}_alertedFBIntegrationSuccessful`) !== "yes";
};
// After failed integration
// TODO add something to state if integration fails
export const showIntegrationFailure = (seg) => {
	return seg?.facebook?.status === "failed" && localStorage.getItem(`${seg?.code}_alertedFBIntegrationFailure`) !== "yes";
};
// Trial days count is 7 or less
export const showTrialUnder7Days = (plan) => {
	return !!plan?.trial_days_remaining && parseInt(plan.trial_days_remaining) <= 7 && parseInt(plan.trial_days_remaining) > 0;
};
// Trial expired
export const showTrialExpired = (plan) => {
	const planState = plan?.state && plan.state.toLowerCase();
	const trialDaysLeft = plan?.trial_days_remaining;
	const planType = plan?.type.toLowerCase();
	return planState === "expired" || (trialDaysLeft < 1 && planType === "trial");
};
// after reinstall and no active paid plan
export const showNoActivePlan = (seg, plan) => {
	const segmentState = seg?.state?.toLowerCase();
	const planState = plan?.state?.toLowerCase();
	const planType = plan?.type?.toLowerCase();
	return planState === "terminated" || (segmentState === "terminated" && planType === "trial");
};
// On first entrance after the segment is set to active
export const showSegmentActive = (seg) => {
	let weekAgo = new Date();
	weekAgo.setDate(weekAgo.getDate() - 7);
	return seg?.state?.toLowerCase() === "active" && seg?.last_state_change > +weekAgo && localStorage.getItem(`${seg?.code}_alertedSegmentActive`) !== "yes";
};
// plan was cancelled
export const showPlanCancelled = (plan_id) => {
	return !!localStorage.getItem(plan_id) && localStorage.getItem(plan_id) !== "alertedPlanCancelled";
};
// no segments for this customer
export const showNoSegments = (segments) => {
	return !(segments && segments.length);
};
